import React, { Component } from 'react'
import { CustomModal } from './Modal'
import ChoiceLineAllSelections from '../ChoiceLines/ChoiceLineAllSelections'
import ChoiceLineSearchSelections from '../ChoiceLines/ChoiceLineSearchSelections'

class ChoiceLineModel extends Component {
  constructor(props) {
    super(props)
    this.state = {
      selectedUnits: [],
      groupedRules: [],
      selectedStructureId: 0,
      credit: 0,
      availableSelections: [],
      removingChoiceLine: false,
      addedSelections: false
    }
  }

  componentDidMount() {
    let selectedUnits = []
    let availableSelections = []
    let credit = 0
    this.props.choiceLineResponse.selections.forEach(choiceLineSelection => {
      choiceLineSelection.selections
        .filter(selection => selection.studentStudyPackageAttempt >= 1)
        .forEach(selection => {
          if (!selectedUnits.some(selectedUnit => selectedUnit.studyPackageNumber === selection.studyPackageNumber)) {
            credit += selection.credit
          }

          selectedUnits.push(selection)
        })
    })

    let addedSelections = false

    this.props.choiceLineSelections.forEach(selection => {
      if (!selectedUnits.some(selectedUnit => selectedUnit.studyPackageNumber === selection.studyPackageNumber)) {
        credit += selection.credit
        selectedUnits.push(selection)
        addedSelections = true
      }
    })

    if (selectedUnits.length > 0) {
      availableSelections = this.state.groupedRules

      let structureListIds = selectedUnits.map(unit => unit.structureListId)

      structureListIds.forEach(structureListId => {
        availableSelections = availableSelections.filter(structureRules => structureRules.rules.some(rule => rule.structureListId === structureListId))
      })
    }
    this.setState({
      groupedRules: this.props.choiceLineResponse.groupedRules,
      availableSelections: availableSelections,
      selectedUnits: selectedUnits,
      credit: credit,
      addedSelections: addedSelections
    })
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevProps.selectedChoiceLine.structureComponentId === this.props.selectedChoiceLine.structureComponentId) {
    } else if (prevProps.selectedChoiceLine.structureComponentId !== this.props.selectedChoiceLine.structureComponentId) {
      this.setState({
        selectedUnits: [],
        selectedStructureId: 0,
        credit: 0
      })
    }
  }

  renderInformation = () => {
    //let rules = React.createElement("div", { 'question-group'}, this.renderChoiceLineIntroRequirements())
    let selections = React.createElement('div', { className: 'question-group' }, this.renderPleaseMakeSelection())

    let selectedChoiceLine = this.props.selectedChoiceLine

    // if (selectedChoiceLine.structureLineDescription) {
    //   selectedChoiceLine.structureLineDescription.forEach((rule, index, choiceLineRulesArray) => {
    //     rules.children.push(React.createElement("div", {}, rule))
    //
    //     if (index < selectedChoiceLine.structureLineDescription.length - 1) {
    //       rules.children.push(<div>OR</div>)
    //     }
    //   })
    // }

    return {
      selectionsDisplay: selections
    }
  }

  renderRule = (rule, selectedChoiceLine, isChoiceLineEqual) => {
    let message = ''
    if (isChoiceLineEqual) {
      if (rule.maximum === rule.minimum) {
        message += this.renderRuleMaximum(rule)
      } else if (rule.maximum + credit === selectedChoiceLine.maximum) {
        message += this.renderRuleMaximum(rule)
      } else if (rule.minimum + credit === selectedChoiceLine.maximum) {
        message += this.renderRuleMinimum(rule)
      } else {
        message += this.renderRuleBetween(rule)
      }
    } else {
      if (rule.maximum === rule.minimum) {
        message += this.renderRuleMaximum(rule)
      } else {
        message += this.renderRuleBetween(rule)
      }
    }
    return message
  }

  handleChoiceLineSubmit = event => {
    event.preventDefault()
    this.props.handleChoiceLineSubmit(this.state.selectedUnits)

    // if (this.state.credit < this.props.selectedChoiceLine.minimum) {
    //   alert("You have not selected the required minimum number of selections")
    // } else {
    //   let selectedUnits = this.state.selectedUnits;
    //   let availableSelections = this.state.groupedRules;
    //
    //   let creditMap = new Map();
    //
    //   selectedUnits.forEach(selectedUnits => {
    //     let credits = creditMap.has(selectedUnits.structureListId) ? creditMap.get(selectedUnits.structureListId) : 0
    //     credits += selectedUnits.credit;
    //
    //     creditMap.set(selectedUnits.structureListId, credits)
    //   })
    //
    //   let rulesMatched = availableSelections.filter(rules => {
    //     return rules.every(rule => {
    //       if (creditMap.has(rule.structureListId)) {
    //         let credit = creditMap.get(rule.structureListId);
    //
    //         return credit <= rule.maximum && credit >= rule.minimum
    //       }
    //
    //       return rule.structureListId === 0;
    //     })
    //   })
    //
    //   if (rulesMatched.length > 0) {
    //     this.props.handleChoiceLineSubmit(this.state.selectedUnits);
    //   } else {
    //     alert("Your selections have not matched any rules");
    //   }
    // }
  }

  handleCancel = event => {
    if (event) {
      event.preventDefault()
    }
    this.props.handleCancel()
  }

  handleUnselection = choiceLineSelect => {
    let selectedUnits = this.state.selectedUnits.filter(choiceLine => choiceLine.studyPackageNumber !== choiceLineSelect.studyPackageNumber)

    let availableSelections = []

    if (selectedUnits.length > 0) {
      let structureListIds = selectedUnits.map(unit => unit.structureListId)

      structureListIds.forEach(structureListId => {
        availableSelections = this.state.groupedRules.filter(structureRules => structureRules.rules.some(rule => rule.structureListId === structureListId))
      })
    }

    return {
      selectedUnits: selectedUnits,
      selectedStructureId: selectedUnits.length > 0 ? this.state.selectedStructureId : 0,
      credit: this.state.credit - choiceLineSelect.credit,
      availableSelections: availableSelections
    }
  }

  handleChoiceLineSelection = (choiceLineSelect, selected = false, event) => {
    event.preventDefault()

    if (selected) {
      if (choiceLineSelect.studentStudyPackageAttempt >= 1) {
        const confirmation = confirm('Any unsaved selection(s) will be lost. Are you sure you want to remove this selection?')

        if (confirmation) {
          this.props.handleChoiceLineRemoval(choiceLineSelect)
        }
      } else {
        this.setState({
          ...this.handleUnselection(choiceLineSelect)
        })
      }
    } else if (this.state.credit === this.props.selectedChoiceLine.maximum) {
      alert('You have already selected the maximum requirement for this option. Please review your selections and try again.')
    } else if (this.state.credit + choiceLineSelect.credit > this.props.selectedChoiceLine.maximum) {
      alert('This selection will exceed the maximum requirement for this option. Please review your selections and try again.')
    } else {
      let selectedUnits = this.state.selectedUnits
      selectedUnits.push(choiceLineSelect)

      let availableSelections = this.state.groupedRules

      let structureListIds = selectedUnits.map(unit => unit.structureListId)

      structureListIds.forEach(structureListId => {
        availableSelections = availableSelections.filter(structureRules => structureRules.rules.some(rule => rule.structureListId === structureListId))
      })

      this.setState({
        selectedUnits: selectedUnits,
        selectedStructureId: choiceLineSelect.structureListId,
        credit: this.state.credit + choiceLineSelect.credit,
        availableSelections: availableSelections,
        addedSelections: true
      })
    }
  }

  renderChoiceLineIntroRequirements = () => {
    // let choiceLine = this.props.selectedChoiceLine;
    // let isEqual = choiceLine.maximum === choiceLine.minimum;
    // let message = "You must select"
    //
    // if (!isEqual) {
    //   message += ` between ${this.props.selectedChoiceLine.minimum} and`
    // }
    //
    // message += ` ${this.props.selectedChoiceLine.maximum}`
    //
    // if (choiceLine.structureRuleCode === "$CP") {
    //   message += " credit points"
    // } else if (choiceLine.structureRuleCode === "$NOC") {
    //   message += choiceLine.maximum === 1 ? " item" : " items"
    // }
    //
    // message += " from the following options:"
    //return React.createElement("div", {class: 'modal-mb-10'}, message)

    return React.createElement('div', { className: 'modal-mb-10' }, this.props.selectedChoiceLine.structureLineIntroduction)
  }

  renderRuleBetween = choiceLineRule => {
    let message = choiceLineRule.structureListDescription
    if (message === null || message === undefined || message.length === 0) {
      message = `Between ${choiceLineRule.minimum} and ${choiceLineRule.maximum} `
      if (choiceLineRule.structureRuleCode === '$CP') {
        message += 'credit points in '
      } else if (choiceLine.structureRuleCode === '$NOC') {
        message += choiceLineRule.maximum === 1 ? ' item in' : ' items in '
      }

      message += choiceLineRule.structureListName
    }

    return message
  }

  renderRuleMaximum = choiceLineRule => {
    let message = choiceLineRule.structureListDescription
    if (message === null || message === undefined || message.length === 0) {
      message = `${choiceLineRule.maximum} `
      if (choiceLineRule.structureRuleCode === '$CP') {
        message += 'credit points in '
      } else if (choiceLine.structureRuleCode === '$NOC') {
        message += choiceLineRule.maximum === 1 ? ' item in ' : ' items in '
      }

      message += choiceLineRule.structureListName
    }

    return message
  }

  renderRuleMinimum = choiceLineRule => {
    let message = choiceLineRule.structureListDescription
    if (message === null || message === undefined || message.length === 0) {
      message = `${choiceLineRule.minimum} `
      if (choiceLineRule.structureRuleCode === '$CP') {
        message += 'credit points in '
      } else if (choiceLine.structureRuleCode === '$NOC') {
        message += choiceLineRule.minimum === 1 ? ' item in ' : ' items in '
      }

      message += choiceLineRule.structureListName
    }

    return message
  }

  renderRules = () => {
    let rules = React.createElement(
      'div',
      { className: 'question-group' },
      this.renderChoiceLineIntroRequirements()
    );
  
    const { choiceLineResponse, selectedChoiceLine } = this.props;
    const parentRuleIds = choiceLineResponse.parentRuleIds;
  
    let children = React.Children.toArray(rules.props.children);
  
    parentRuleIds.forEach((element, index) => {
      const structureRule = choiceLineResponse.structuredRules[element];
      const parentRule = structureRule.parentRule;
      const listOfRules = [];
  
      if (parentRule.structureRuleCode !== 'NA') {
        let message = this.renderRule(parentRule, selectedChoiceLine, false);
  
        if (structureRule.rules?.length > 0) {
          message += ` ${parentRule.structureRuleOperationCode} `;
        }
  
        listOfRules.push(
          React.createElement('li', { key: `parent-${parentRule.structureRuleId}` }, message)
        );
      }
  
      if (structureRule.rules?.length > 0) {
        structureRule.rules.forEach((rule, i) => {
          let message = this.renderRule(rule, selectedChoiceLine, false);
          if (i < structureRule.rules.length - 1) {
            message += ` ${rule.structureRuleOperationCode} `;
          }
          listOfRules.push(
            React.createElement('li', { key: `child-${rule.structureRuleId}` }, message)
          );
        });
      }
  
      children.push(React.createElement('ul', { key: `ul-${index}` }, listOfRules));
  
      if (index < parentRuleIds.length - 1) {
        children.push(
          React.createElement('div', { key: `op-${index}` }, parentRule.structureRuleOperationCode)
        );
      }
    });
  
    return React.cloneElement(rules, {}, children);
  };
  

  renderSelectionHeader = () => {
    return React.createElement('div', { className: 'modal-mb-10' }, 'Please make your selection(s) below:')
  }

  renderSelections = () => {
    let ruleStructureListId = []
    let itemsToRender = []

    this.props.choiceLineResponse.selections.map((choiceLine, index) => {
      if (!ruleStructureListId.includes(choiceLine.rule.structureListId + choiceLine.rule.structureListName)) {
        ruleStructureListId.push(choiceLine.rule.structureListId + choiceLine.rule.structureListName)
        if (choiceLine.rule.structureSelection || choiceLine.rule.selectionCount <= 20) {
          itemsToRender.push(
            <ChoiceLineAllSelections
              key={`${choiceLine.rule.structureListId}_${choiceLine.rule.structureListName}`}
              choiceLine={choiceLine}
              handleChoiceLineSelection={this.handleChoiceLineSelection}
              availableSelections={this.state.availableSelections}
              selectedUnits={this.state.selectedUnits}
            />
          )
        } else {
          itemsToRender.push(
            <ChoiceLineSearchSelections
              key={`${choiceLine.rule.structureListId}_${choiceLine.rule.structureListName}`}
              choiceLine={choiceLine}
              handleChoiceLineSelection={this.handleChoiceLineSelection}
              availableSelections={this.state.availableSelections}
              selectedUnits={this.state.selectedUnits}
            />
          )
        }
      }
    })
    return itemsToRender
  }

  renderSelectionFooter = () => {
    let choiceLine = this.props.selectedChoiceLine
    let isEqual = choiceLine.maximum === choiceLine.minimum
    let message = `${this.state.credit} /`

    if (!isEqual) {
      message += ` ${this.props.selectedChoiceLine.minimum} to`
    }

    message += ` ${this.props.selectedChoiceLine.maximum}`

    if (choiceLine.structureRuleCode === '$CP') {
      message += ' credit points'
    } else if (choiceLine.structureRuleCode === '$NOC') {
      message += choiceLine.maximum === 1 ? ' item' : ' items'
    }

    message += ' selected'

    return React.createElement('div', { className: 'modal-mb-10' }, message)
  }

  render() {
    return (
      <CustomModal className="modal-sxl modal-manage-enrolment" isOpen={this.props.openChoiceLineModel} userCanClose={true} handleCloseModal={() => this.handleCancel()} title="Selection Options">
        <div>
          <h3>{this.props.selectedChoiceLine.choiceDescription}</h3>
        </div>

        {this.props.displayError && (
          <div className="sidenote sidenote--error">
            <div className="sidenote__content">{this.props.errorMessage}</div>
          </div>
        )}

        {this.renderRules()}

        <div className={'question-group'}>
          {this.renderSelectionHeader()}
          {this.renderSelections()}
        </div>

        <div className="question-group">
          <div className="form-items-group"><strong>{this.renderSelectionFooter()}</strong></div>
        </div>

        {(this.state.credit < this.props.selectedChoiceLine.maximum || this.state.addedSelections) && (
          <div className="question-group">
            <div className="form-items-group">Once you have finalised your selection, click ‘Save and continue’ to proceed with your unit enrolment.</div>
          </div>
        )}

        <div className="row">
          {(this.state.credit < this.props.selectedChoiceLine.maximum || this.state.addedSelections) && (
            <div className="modal-button-center col-xs-12 col-sm-6">
              <button onClick={event => this.handleChoiceLineSubmit(event)} className="btn btn-lg btn-primary">
                <span>{'Save and continue'}</span>
              </button>
            </div>
          )}
          <div className="modal-button-center col-xs-12 col-sm-6">
            <button onClick={event => this.handleCancel(event)} className="btn btn-lg btn-secondary">
              <span>{'Cancel'}</span>
            </button>
          </div>
        </div>
      </CustomModal>
    )
  }
}

export default ChoiceLineModel
